import { connect } from 'react-redux';
import View from './FinancialPlanCapsuleWrapperView';
import * as Actions from './FinancialPlanCapsuleWrapperActions';
import * as PlanSelectionActionsNewWhatIfs from '../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsActions';

import {
  clientId,
  capsuleId,
  fpId,
  name,
  hasFpId,
  isCurrentSelector,
} from './FinancialPlanCapsuleWrapperSelector';

const mapStateToProps = (state, ownProps) => {
  const _clientId = clientId(state, ownProps),
    subdivision = state.FinancialPlanCapsuleWrapper[_clientId];
  return {
    clientId: _clientId,
    capsuleId: capsuleId(state, ownProps),
    fpId: fpId(state, ownProps),
    hasFpId: hasFpId(state, ownProps),
    proposed_plan: name(state, ownProps),
    isCurrent: isCurrentSelector(state, ownProps),
    hasData: subdivision ? subdivision.hasData : false,
  };
};

const mapDispatchToProps = dispatch => ({
  fetchData(capsuleId, clientId) {
    dispatch(PlanSelectionActionsNewWhatIfs.fetchDataIfNecessary(clientId));
    dispatch(Actions.fetchDefaultFpId(capsuleId, clientId));
  },
  resetData(capsuleId, clientId) {
    dispatch(Actions.setCapsuleFpIdWithoutCaching(null, capsuleId, clientId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
